export default __webpack_public_path__ + "static/media/Vector.6ff1fe0e.svg";